import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import {
  FINANCE,
  FINANCE_AMOUNT,
  FORM_AUTO,
  FORM_CONSUMO,
  FORM_MG,
  OPERATIVE_ESC,
  REQUEST_DATA,
  REQUEST_MODE_EDIT,
  REQUEST_MODE_NEW,
  REQUEST_MODE_VIEW,
} from '@app/@core/constants/requests.constants';
import { CombosStore } from '@app/requests/combos-service/combos.store';
import {
  CalculatorAutosDTO,
  CalculatorControlPanel,
  CalculatorDTO,
  CalculatorResponseDTO,
  CalculatorReturnDTO,
  FinancingCallDTO,
} from './../../model/requests-model';
import { RequestsSaveSendStore } from '../../requests-save-send-service/requests-save-send.store';
import { RequestFinanceService } from './request-finance.service';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { TransformNumberPipe } from '@app/@shared/pipes/transform-number.pipe';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '@app/login';
import { Subject } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';
import { MatRadioChange } from '@angular/material/radio';
import { UserDivisions } from '@app/@core/constants/user-credentials.constants';
@Component({
  selector: 'scf-request-finance',
  templateUrl: './request-finance.component.html',
  styleUrls: ['./request-finance.component.scss'],
})
export class RequestFinanceComponent implements OnInit {
  displayedColumns: string[] = [
    'select',
    'type',
    'term',
    'firstCuota',
    'cuota',
    'lastCuota',
    'tin',
    'cae',
    'treatmentCae',
    'tae',
    'safe',
  ];
  displayedColumnsNoConsumo: string[] = ['select', 'type', 'firstCuota', 'cuota', 'lastCuota', 'tin', 'safe'];
  @Input('dataCallSimulation') set dataCallSimulation(data: any) {
    if (data) {
      this.requestDataCallSimulation = data.request;
      this.clickButtonCalculate = data.click;
      this.getDataFinanceSimulation(data.request, data.export);
    }
  }

  selection = new SelectionModel<CalculatorResponseDTO | CalculatorReturnDTO>();

  @Input() public establishment: string;
  @Input('operative') set dataOperative(data: any) {
    if (data) {
      this.operative = data;
      this.selection = new SelectionModel<CalculatorResponseDTO | CalculatorReturnDTO>(false, []);
    }
  }
  @Input() public request: any = null;
  @Input() public isCalculator: boolean;
  @Output() public switchScreen = new EventEmitter<any>();
  @Output() public changeContinueStatus = new EventEmitter<any>();
  @Output() public loading = new EventEmitter<boolean>(false);
  @Input() public mode: string = 'new';
  @Output() public changeExpiredMonth = new EventEmitter<any>();
  @Output() public isFinishedLoading = new EventEmitter<any>();
  @Input() changing: Subject<boolean>; //para limpiar la tabla cuando el usuario le de a limpiar campos

  dataSource = new MatTableDataSource<CalculatorDTO>();
  maxAmount: any;
  public financeForm: FormGroup;
  private requestDataCallSimulation: FinancingCallDTO | CalculatorAutosDTO;
  private clickButtonCalculate: boolean = false;
  public operative: string = null;
  public expired: string = '';
  public haveDeadline: boolean = false;
  public showFirstDayPayment: boolean = false;
  excludes: boolean;
  formSeguros: string;
  selectedValue: CalculatorDTO;
  isCalculatorData: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private requestStore: RequestsSaveSendStore,
    private requestFinanceService: RequestFinanceService,
    private combosStore: CombosStore,
    private dialog: MatDialog,
    private transformNumberPipe: TransformNumberPipe,
    private translateService: TranslateService,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit(): void {
    this.changing.subscribe((v) => {
      this.dataSource.data = [];
    });

    this.createForm();
    if (this.requestStore.getMarcaFormulario() === FORM_MG) {
      this.requestStore.setFormularioMg(this.financeForm, FINANCE);
    } else if (this.requestStore.getMarcaFormulario() === FORM_CONSUMO) {
      if (!this.requestStore.listaFormulariosConsumo[FINANCE]) {
        this.requestStore.setFormularioConsumo(this.financeForm, FINANCE);
      }
    } else if (this.requestStore.getMarcaFormulario() === FORM_AUTO) {
      if (!this.requestStore.listaFormulariosAutos[FINANCE]) {
        this.requestStore.setFormularioAutos(this.financeForm, FINANCE);
      }
    }

    this.financeForm.statusChanges.subscribe(() => {
      if (this.financeForm) {
        this.changeContinueStatus.emit({ form: <FormGroup>this.financeForm, id: FINANCE });
      }
    });

    if (this.mode !== REQUEST_MODE_VIEW) {
      this.financeForm.reset();
    }

    if (!this.requestDataCallSimulation) {
      this.isFinishedLoading.emit({ formID: FINANCE, value: true });
    }

    this.requestStore.isCalculatorData$.subscribe((data) => {
      this.isCalculatorData = data;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.establishment) {
      this.reset();
    }
  }

  hasAnyFinancing(): boolean {
    return this.dataSource.data.length > 0;
  }

  createRequest() {
    if (this.requestStore.getMarcaFormulario() === FORM_CONSUMO) {
      this.requestStore.setFinanceAmountData(this.requestStore.listaFormulariosConsumo[FINANCE_AMOUNT]);
      this.requestStore.setRequestDataUptake(this.requestStore.listaFormulariosConsumo[REQUEST_DATA]);
    }
    this.switchScreen.emit(true);
  }

  getDataFinanceSimulation(data: FinancingCallDTO | CalculatorAutosDTO, isExport: boolean, valueSelected?: any) {
    if (data) {
      this.haveDeadline = data.installments && data.installments.length > 0 ? false : true;
      this.isFinishedLoading.emit({ formID: FINANCE, value: false });
      //this.loading.emit(true);
      this.requestFinanceService
        .financingSimulation(data)
        .subscribe((finances: CalculatorResponseDTO) => {
          this.showFirstDayPayment = finances.financialProduct !== '30';
          this.dataSource.data = finances.lstCalculatorFinancings.reverse();
          this.expired = finances.strExpireDate;
          if (finances.financialProduct != '10' && finances.financialProduct != '30') {
            this.displayedColumns = this.displayedColumnsNoConsumo;
          }
          if (!finances.isCuotaBallom) {
            this.displayedColumns = this.displayedColumns.filter((obj) => obj !== 'lastCuota');
          }
          if (isExport && this.dataSource.data.length > 0) {
            this.managePDFControlPanel(finances.controlPanels);
          }
          this.formSeguros = finances.assuranceEducation;
        })
        .add(() => {
          if (
            this.requestStore.getMarcaFormulario() === FORM_AUTO ||
            this.requestStore.getMarcaFormulario() === FORM_CONSUMO
          ) {
            let listaFormularios =
              this.requestStore.getMarcaFormulario() === FORM_AUTO
                ? this.requestStore.listaFormulariosAutos
                : this.requestStore.listaFormulariosConsumo;

            if (this.mode !== REQUEST_MODE_NEW) {
              if (!this.clickButtonCalculate) {
                const index = this.dataSource.data.findIndex((value: CalculatorReturnDTO) => {
                  return this.request.tariffSelected ? value.insurance == this.request.codpac : false;
                });
                if (index > -1) {
                  this.selection.select(this.dataSource.data[index]);
                  this.financeForm.controls.finance.setValue(this.dataSource.data[index]);
                } else {
                  this.selection.select(this.dataSource.data[0]);
                  this.financeForm.controls.finance.setValue(this.dataSource.data[0]);
                }
              }
              this.selectRadioButtonFinance(listaFormularios);
            } else {
              if (this.requestStore.getCalculatorData()) {
                let financingSelected = this.requestStore.getFinancingData();
                if (financingSelected) {
                  this.financeForm.controls.finance.setValue(financingSelected);
                  const index = this.dataSource.data.findIndex((value: CalculatorReturnDTO) => {
                    return (
                      value.insurance == listaFormularios[FINANCE].controls.finance.value.insurance &&
                      value.share == listaFormularios[FINANCE].controls.finance.value.share
                    );
                  });
                  if (index > -1) {
                    this.selection.select(this.dataSource.data[index]);
                    this.financeForm.controls.finance.setValue(this.dataSource.data[index]);
                  }
                } else {
                  this.financeForm.controls.finance.setValue(this.dataSource.data[0]);
                }
                this.requestStore.setCalculatorData(false);
              } else {
                if (!isExport) {
                  this.selectRadioButtonInsuranceLife();
                } else {
                  const index = this.dataSource.data.findIndex((value: CalculatorReturnDTO) => {
                    return value.insurance == valueSelected.insurance && value.share == valueSelected.share;
                  });
                  if (index > -1) {
                    this.selection.select(this.dataSource.data[index]);
                    this.financeForm.controls.finance.setValue(this.dataSource.data[index]);
                    this.requestStore.setFinancingData(this.dataSource.data[index]);
                  }
                }
              }
            }

            this.financeForm.controls.expirationDate.setValue(this.expired);
            if (this.expired && this.hasAnyFinancing()) {
              this.changeExpiredMonth.emit(
                this.combosStore.monthsList[parseInt(this.expired.split('/', 3)[1]) - 1].value
              );
            } else {
              this.changeExpiredMonth.emit(null);
            }
          } else {
            this.financeForm.controls.expirationDate.setValue(this.expired);
            this.selection.select(this.dataSource.data[0]);
            this.financeForm.controls.finance.setValue(this.dataSource.data[0]);
          }

          this.financeForm.controls.finance.updateValueAndValidity();
          this.isFinishedLoading.emit({ formID: FINANCE, value: true });
        });
    } else {
      this.dataSource.data = [];
      this.financeForm.reset();
    }
  }

  private createForm() {
    this.financeForm = this.formBuilder.group({
      finance: ['', Validators.required],
      expirationDate: '',
      remember: true,
    });
  }

  private selectRadioButtonInsuranceLife() {
    const index = this.dataSource.data.findIndex((value: CalculatorReturnDTO) => {
      return value.insurance == 'VA';
    });
    if (index > -1) {
      if (this.formSeguros !== 'S') {
        this.selection.select(this.dataSource.data[0]);
        this.financeForm.controls.finance.setValue(this.dataSource.data[0]);
        this.requestStore.setFinancingData(this.dataSource.data[0]);
      } else {
        this.selection.select(this.dataSource.data[index]);
        this.financeForm.controls.finance.setValue(this.dataSource.data[index]);
        this.requestStore.setFinancingData(this.dataSource.data[index]);
      }
    } else {
      this.selection.select(this.dataSource.data[0]);
      this.financeForm.controls.finance.setValue(this.dataSource.data[0]);
      this.requestStore.setFinancingData(this.dataSource.data[0]);
    }
  }

  managePDFControlPanel(body: CalculatorControlPanel[]) {
    if (this.requestStore.getMarcaFormulario() === FORM_AUTO) {
      this.createPDFControlPanelAutos(body);
    } else if (
      this.requestStore.getMarcaFormulario() === FORM_CONSUMO &&
      !this.authenticationService.isGS() &&
      !this.authenticationService.isRepsol()
    ) {
      this.createPDFControlPanelConsumo(body);
    }
  }

  createPDFControlPanelAutos(body: CalculatorControlPanel[]) {
    try {
      let doc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: [209, 296],
      });

      const date = new Date();
      const month = date.getMonth() + 1;
      doc.setProperties({
        title: 'CuadroDeAmortización_' + date.getDate() + month + date.getFullYear(),
      });

      const dataPdf = this.generateBodyPdf(body);

      const margin = 12;
      const pageWidth = doc.internal.pageSize.width;
      const tableWidth = pageWidth - margin * 2;
      const startXY = { X: 10, Y: 2 };
      const cellWidth = tableWidth / 5;
      const lineheight = 5;
      const whiteSpace = 3;

      /* HEADER */
      doc.setFontSize(10);
      doc.setFont(undefined, 'bold');
      doc.setTextColor('#000000');

      //Title
      const titleXY = { X: pageWidth / 2, Y: 30 };
      const selectionTariff = this.requestDataCallSimulation.finance ? this.requestDataCallSimulation.finance - 1 : 0;

      let financinglist: CalculatorDTO[] = JSON.parse(JSON.stringify(this.dataSource.data));
      financinglist.reverse();

      const tariff =
        financinglist[selectionTariff]?.description +
        ' - ' +
        (financinglist[selectionTariff].insuranceDescription
          ? financinglist[selectionTariff].insuranceDescription
          : 'SIN PROTECCIÓN');

      doc.text(
        this.translateService.instant('calculator.pdf.controlpanel.autos.title').toUpperCase(),
        titleXY.X,
        titleXY.Y,
        { align: 'center' }
      );
      doc.text(tariff, titleXY.X, titleXY.Y + lineheight, { align: 'center' });

      doc.setFontSize(8);
      //Head Table
      const headerTableXY = { X: startXY.X, Y: 45 };
      const noticeParagraph = this.translateService.instant('calculator.pdf.controlpanel.header');
      const firstHeaderTop = this.translateService.instant('calculator.pdf.controlpanel.table.title');

      doc.setFont(undefined, 'normal');
      doc.text(noticeParagraph, headerTableXY.X, headerTableXY.Y);

      doc.setFont(undefined, 'bold');
      doc.text(firstHeaderTop, headerTableXY.X, headerTableXY.Y + lineheight);

      doc.line(
        headerTableXY.X,
        headerTableXY.Y + lineheight + 2,
        headerTableXY.X + tableWidth,
        headerTableXY.Y + lineheight + 2
      );

      autoTable(doc, {
        startY: 55,
        tableWidth: tableWidth,
        rowPageBreak: 'avoid',
        showHead: 'everyPage',
        margin: { top: 30, left: margin, right: margin },
        head: [
          [
            this.translateService.instant('calculator.pdf.controlpanel.autos.expirationDay').toUpperCase(),
            this.translateService.instant('calculator.pdf.controlpanel.autos.costTerm').toUpperCase(),
            this.translateService.instant('calculator.pdf.controlpanel.autos.amortization').toUpperCase(),
            this.translateService.instant('calculator.pdf.controlpanel.autos.interests').toUpperCase(),
            this.translateService.instant('calculator.pdf.controlpanel.autos.pending').toUpperCase(),
          ],
        ],
        headStyles: {
          cellWidth: cellWidth,
          fillColor: '#FFFFFF',
          fontSize: 8,
          fontStyle: 'bold',
          textColor: '#000000',
          halign: 'center',
          valign: 'middle',
        },
        body: dataPdf.map(Object.values),
        bodyStyles: {
          fontSize: 8,
          fillColor: '#FFFFFF',
          textColor: '#000000',
          cellWidth: cellWidth,
          halign: 'center',
          valign: 'middle',
          cellPadding: { horizontal: 1, vertical: 1 },
        },
        columnStyles: {
          0: { fillColor: '#FFFFFF' },
          1: { fillColor: '#FFFFFF' },
          2: { fillColor: '#FFFFFF' },
          3: { fillColor: '#FFFFFF' },
          4: { fillColor: '#FFFFFF' },
        },
        didDrawCell: (data) => {
          if (data.row.index === dataPdf.length - 1) {
            const marginCell = 10;
            doc.setLineDashPattern([2, 1], 0);
            doc.setDrawColor('#000000');
            doc.line(data.cell.x + marginCell, data.cell.y, data.cell.x + cellWidth - marginCell, data.cell.y);
          }
        },
        didDrawPage: () => {
          /* HEADER */
          var img = new Image();
          img.src = 'assets/img/logo.PNG';
          doc.addImage(img, 'png', startXY.X, startXY.Y, 50, 20);
        },
      });

      doc.save('CuadroDeAmortización_Autos_' + date.getDate() + month + date.getFullYear());
    } catch (error) {
      console.error(error);
    }
  }

  private isMaxAmountNotValid(amount: any) {
    return this.maxAmount && amount > this.maxAmount;
  }

  createPDFControlPanelConsumo(body: CalculatorControlPanel[]) {
    try {
      let doc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: [209, 296],
      });

      const date = new Date();
      let month = date.getMonth() + 1;
      doc.setProperties({
        title: 'CuadroDeAmortización_' + date.getDate() + month + date.getFullYear(),
      });

      const dataPdf = this.generateBodyPdf(body);

      const margin = 12;
      const pageWidth = doc.internal.pageSize.width;
      const tableWidth = (pageWidth - margin * 2) / 2;
      const startXY = { X: 10, Y: 2 };
      const lineheight = 5;
      const whiteSpace = 3;

      /* HEADER */
      doc.setFontSize(10);
      doc.setFont(undefined, 'bold');
      doc.setTextColor('#000000');

      //Title
      const titleXY = { X: pageWidth / 2, Y: 30 };
      //We have to do like this because dataSource is reversed, so we have to take the real position in the table
      const selectionTariff = this.dataSource.data.length - this.requestDataCallSimulation.finance;
      const tariffSelected = this.dataSource.data[selectionTariff];
      const tariff =
        tariffSelected.description +
        ' - ' +
        (tariffSelected.insuranceDescription ? tariffSelected.insuranceDescription : 'SIN PROTECCIÓN');
      doc.text(
        this.translateService.instant('calculator.pdf.controlpanel.consumption.title').toUpperCase(),
        titleXY.X,
        titleXY.Y,
        { align: 'center' }
      );
      doc.text(tariff, titleXY.X, titleXY.Y + lineheight, { align: 'center' });

      //Head Table
      doc.setFontSize(8);
      const headerTableXY = { X: 11, Y: 38 };
      const firstHeaderTop = this.translateService.instant('calculator.pdf.controlpanel.table.title');

      doc.setFont(undefined, 'normal');
      doc.text(firstHeaderTop, headerTableXY.X + whiteSpace, headerTableXY.Y + lineheight);

      const bodyTable = dataPdf.map(Object.values);
      const firstHalf = bodyTable.slice(0, bodyTable.length / 2);
      let indexSeparator: number = bodyTable.length % 2 === 0 ? 0 : 1;
      const secondHalf = bodyTable.slice(-(bodyTable.length / 2 + indexSeparator));

      //FIRST TABLE
      this.autoTableConsumo(doc, firstHalf, startXY, margin, tableWidth + margin);

      //SECOND TABLE
      this.autoTableConsumo(doc, secondHalf, startXY, tableWidth + margin, margin);

      doc.save('CuadroDeAmortización_Consumo_' + date.getDate() + month + date.getFullYear());
    } catch (error) {
      console.error(error);
    }
  }

  private generateBodyPdf(body: CalculatorControlPanel[]) {
    let totals: number[] = [0, 0, 0];
    // /* BODY */
    const dataPdf: any[] = body.map((item) => {
      const { cuotaC, amor, intere } = item;

      totals[0] += cuotaC;
      totals[1] += amor;
      totals[2] += intere;

      return [
        item.fecvct?.replace(/\//g, '-'),
        this.transformNumberPipe.transform(item.cuotaC),
        this.transformNumberPipe.transform(item.amor),
        this.transformNumberPipe.transform(item.intere),
        this.transformNumberPipe.transform(item.capIni),
      ];
    });

    dataPdf.push([
      'TOTAL',
      this.transformNumberPipe.transform(totals[0]),
      this.transformNumberPipe.transform(totals[1]),
      this.transformNumberPipe.transform(totals[2]),
      '',
    ]);

    return dataPdf;
  }

  private autoTableConsumo(doc: any, body: any, startXY: any, marginLeft: number, marginRight: number) {
    const margin = 12;
    const pageWidth = doc.internal.pageSize.width;
    const tableWidth = (pageWidth - margin * 2) / 2;
    const cellWidth = tableWidth / 5;

    autoTable(doc, {
      startY: 45,
      tableWidth: tableWidth,
      rowPageBreak: 'avoid',
      showHead: 'everyPage',
      margin: { top: 45, left: marginLeft, right: marginRight },
      head: [
        [
          this.translateService.instant('calculator.pdf.controlpanel.consumption.expirationDay').toUpperCase(),
          this.translateService.instant('calculator.pdf.controlpanel.consumption.costTerm').toUpperCase(),
          this.translateService.instant('calculator.pdf.controlpanel.consumption.amortization').toUpperCase(),
          this.translateService.instant('calculator.pdf.controlpanel.consumption.interests').toUpperCase(),
          this.translateService.instant('calculator.pdf.controlpanel.consumption.pending').toUpperCase(),
        ],
      ],
      headStyles: {
        fillColor: '#FFFFFF',
        fontSize: 7,
        fontStyle: 'bold',
        textColor: '#000000',
        halign: 'center',
        valign: 'middle',
      },
      body: body,
      bodyStyles: {
        fontSize: 8,
        fillColor: '#FFFFFF',
        textColor: '#000000',
        halign: 'center',
        valign: 'middle',
        cellPadding: { vertical: 0.75 },
      },
      columnStyles: {
        0: { fillColor: '#FFFFFF' },
        1: { fillColor: '#FFFFFF' },
        2: { fillColor: '#FFFFFF' },
        3: { fillColor: '#FFFFFF' },
        4: { fillColor: '#FFFFFF' },
      },
      didDrawPage: (data) => {
        const cellsHeader = data.table.head[0].cells;
        const padding = 0.75 * 2;
        doc.setDrawColor('#000000');
        doc.line(
          cellsHeader[0].x + padding,
          cellsHeader[0].y + cellsHeader[0].contentHeight - 0.2,
          cellsHeader[4].x + cellWidth + padding,
          cellsHeader[0].y + cellsHeader[0].contentHeight - 0.2
        );

        /* HEADER */
        var img = new Image();
        img.src = 'assets/img/logo.PNG';
        doc.addImage(img, 'png', startXY.X, startXY.Y, 50, 20);
      },
    });
  }

  isAllSelected() {
    let cont: number = 0;
    let term: string = null;
    const numSelected = this.selection.selected.length;
    this.dataSource.data.forEach((row: CalculatorReturnDTO) => {
      if (row.term !== term) {
        cont++;
      }
      term = row.term;
    });
    const numRows = this.dataSource.data.length;
    return numSelected === numRows || cont === numSelected;
  }

  masterToggle() {
    let term: string = null;
    if (this.isAllSelected()) {
      this.selection.clear();
      this.financeForm.controls.finance.setValue(null);
    } else {
      this.dataSource.data.forEach((row) => {
        if (row.term !== term) {
          this.selection.select(row);
        }
        term = row.term;
      });
      this.financeForm.controls.finance.setValue(this.selection.selected);
    }
  }

  sameTerm(data: CalculatorDTO) {
    this.financeForm.controls.finance.setValue(this.selection.selected.length === 0 ? null : this.selection.selected);
    this.disableRow(data);
  }

  disableRow(data: CalculatorDTO) {
    let disabled: boolean = false;

    this.selection.selected.forEach((row: CalculatorReturnDTO) => {
      if (data.term === row.term && data.idTariff !== row.idTariff) {
        disabled = true;
      }
    });

    return disabled;
  }

  changeElementFinance(element: CalculatorDTO, event: MatRadioChange) {
    if (element) {
      if (this.formSeguros !== 'S') {
        if (!(element.insurance === '99' || element.insurance === '')) {
          event.source.checked = false;
          event.source.value = this.financeForm.controls.finance.value;
          event.value = this.financeForm.controls.finance.value;
        } else {
          this.selection.toggle(element);
          this.selectedValue = element;
          this.requestStore.setFinancingData(element);
        }
      } else {
        this.selection.toggle(element);
        this.selectedValue = element;
        this.requestStore.setFinancingData(element);
      }
    } else {
      this.selectedValue = null;
    }
  }

  private showDialogError(err: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '450px';
    dialogConfig.panelClass = '.faction-dialog';
    dialogConfig.data = { text: err, icon: 'icon-ic_circle_cross_red', noRedirect: true };
    this.dialog.open(ResponseDialogComponent, dialogConfig);
  }

  onclick(element: CalculatorDTO) {
    if (element && this.formSeguros !== 'S' && !(element.insurance === '99' || element.insurance === '')) {
      this.showDialogError(this.translateService.instant('requestFinance.noFormacionSeguros'));
    }
  }

  onClickPrintControlPanel() {
    let financinglist: CalculatorDTO[] = JSON.parse(JSON.stringify(this.dataSource.data));
    financinglist.reverse();
    const index = financinglist.findIndex((value: CalculatorReturnDTO) => {
      return this.financeForm.controls.finance.value
        ? value.insuranceDescription == this.financeForm.controls.finance.value.insuranceDescription
        : false;
    });

    this.requestDataCallSimulation.finance = index + 1;
    this.getDataFinanceSimulation(this.requestDataCallSimulation, true, this.financeForm.controls.finance.value);
  }

  private selectRadioButtonFinance(listaFormularios: any) {
    // it searchs the index that matches the selected option
    // if it's the first time that goes by this part, no option is selected yet, so it gets index = -1, and in the next 'if' sets firts option
    let index = -1;
    if (!this.clickButtonCalculate) {
      index = this.dataSource.data.findIndex((value: CalculatorReturnDTO) => {
        return listaFormularios[FINANCE].controls.finance.value
          ? value.insuranceDescription == listaFormularios[FINANCE].controls.finance.value.insuranceDescription
          : false;
      });
    }
    if (index > -1) {
      this.selection.select(this.dataSource.data[index]);
      this.financeForm.controls.finance.setValue(this.dataSource.data[index]);
    } else {
      if (this.formSeguros !== 'S') {
        //buscar el indice que no tiene seguro
        const indexWithoutInsurance = this.dataSource.data.findIndex((value: CalculatorReturnDTO) => {
          return value.insurance === '99' || value.insurance === '';
        });
        this.selection.select(this.dataSource.data[indexWithoutInsurance]);
        this.financeForm.controls.finance.setValue(this.dataSource.data[indexWithoutInsurance]);
      } else {
        //buscar el indice tiene seguro PARA AUTOS POR DEFECTO
        if (this.requestStore.getMarcaFormulario() === FORM_AUTO) {
          const indexWithoutInsurance = this.dataSource.data.findIndex((value: CalculatorReturnDTO) => {
            return value.insurance === 'VA';
          });
          this.selection.select(this.dataSource.data[indexWithoutInsurance]);
          this.financeForm.controls.finance.setValue(this.dataSource.data[indexWithoutInsurance]);
        } else {
          this.selection.select(this.dataSource.data[0]);
          this.financeForm.controls.finance.setValue(this.dataSource.data[0]);
        }
      }
    }
  }

  private reset = () => {
    this.dataSource.data = [];
    this.selection?.clear();
    this.financeForm?.reset();
  };
}
